// LensPowerCalculator.js
import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import SharedLensPowerCalculator from "./SharedLensPowerCalculator";
const TITLE =
  "Kalkulator Kekuatan Lensa Mata - Pelajari Cara Menghitung Lensa Mata dan Kekuatan Optiknya";
const DESCRIPTION =
  "Kalkulator kekuatan lensa elektronik: Hitung kekuatan lensa medis (dalam dioptri) dengan sangat akurat! Masukkan indeks bias lensa dan jari-jari kelengkungan untuk mengetahui kekuatan optik - alat penting untuk dokter mata dan teknisi kacamata medis.";
const KEYWORDS = "menghitung lensa mata, menghitung kekuatan optik";
const OG_URL = "https://do-calculate.com/calculator/id/lenspower";
function Calculator() {
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kekuatan lensa optik menyatakan kemampuannya untuk mengumpulkan sinar menuju pusat
                  optik utama. Simbol kekuatan lensa dilambangkan dengan huruf "C". Kekuatan
                  lensa berbanding terbalik dengan panjang fokus, artinya semakin besar panjang
                  fokus, semakin kecil kekuatan lensa, dan sebaliknya.
                  <br />
                  Kekuatan lensa dapat dihitung menggunakan persamaan C = 1/F, di mana F
                  adalah panjang fokus. Nilai C positif untuk lensa cembung,
                  sedangkan negatif untuk lensa cekung."
                  <br />
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <SharedLensPowerCalculator />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;